import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutionrev() {
  return (
    <section className="solution_rev p-100 text_white bg_purple_color">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              The
              <span style={{ color: "#E8E751" }}> Solution</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              Rev Coin provides a comprehensive solution to the tests faced by
              traditional loyalty programs.
            </p>
            <p>
              As an ERC20 token deployed on the Ethereum blockchain, Rev Coin
              offers employees with a protected and transparent medium to hold
              company shares.
            </p>
            <p>
              The technical implementation includes utilizing smart contracts to
              allow unified transactions, efficient fund management, and
              accurate account balances.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/rev-coin/sol_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={694}
                height={516}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionrev;
